import styled from "styled-components"

const NavigationItems = styled.ol`
  align-items: center;
  flex-direction: row;
  display: flex;
  list-style: 0;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
`

export default NavigationItems



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/NavigationItems.js